<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
  <nav class="" id="vy_header ">
    <h1 >
          <span v-on:click="ichiran" style="cursor: pointer;">
            <img v-if="header_logo" id="vy-logo" v-bind:src="header_logo" alt="ボラ活エール"/>
            <img v-else id="vy-logo" src="../../images/logo.png" alt="ボラ活エール" style="width:100%;height:auto" />

            <div style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        text-align: center;">
            <b :style="title_style1">{{ header_title1 }}</b>
            <b :style="title_style2">{{ header_title2 }}</b>
            </div>
          </span>
    </h1>
    <div class="container">
    </div>
  </nav>
  <div>
    <table class="vy-search-form-table-nav">
            <!-- フリーワード -->
            <tr>
              <th>
                <label for="keyword">フリーワード</label>
              </th>
              <td style="text-align: left;">
                <input type="text" placeholder="プログラム名、受入先、会場情報、活動内容、備考" class="form-control" id="keyword0" name="keyword0" v-model="keyword0"
                v-on:change="Check()" 
                @keyup.enter.prevent="Check">
                
              </td>
            </tr>
          
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
      <!-- 場所（分類1） -->
      <tr>
              <th>
                <label for="bunrui1">分類1</label>
              </th>
              <td style="text-align: left;">
                <select class="form-control" name="bunrui10" id="bunrui10" v-model="bunrui10" v-on:change="bunrui1_change()" >
                  <option value="全て">全て</option>
                  <option v-for:="(bunrui1_row,i) in bunrui1_list" v-bind:value="bunrui1_row">{{i+1}}．{{ bunrui1_row }}</option>
                </select>
              </td>
            </tr>

            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
              
            <tr>
              <th>
                <label for="bunrui1">分類2</label>
              </th>
              <td style="text-align: left;">
                <select class="form-control" name="bunrui20" id="bunrui20" v-model="bunrui20" v-on:change="Check()" >
                  <option value="全て">全て</option>
                  <option v-for:="(bunrui2_row,i) in bunrui2_list_Extract" v-bind:value="bunrui2_row">{{i+1}}．{{ bunrui2_row }}</option>
                </select>
              </td>
            </tr>

            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
              
            <tr>
              <th>
                <label for="shimekiri">申込受付</label>
              </th>
              <td style="text-align: left;">
                <select class="form-control" name="shimekiri0" id="shimekiri0" v-model="shimekiri0" v-on:change="Check()" >
                  <option value="0">全て</option>
                  <option value="1">受付中のみ</option>
                  <option value="2">受付終了のみ</option>
                </select>
              </td>
            </tr>
      <tr>
        <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <!-- 日程 -->
      <tr>
        <th>
          <label for="kaisai_date">開催日</label>
        </th>
        <td style="text-align: left;">
          <div class="container">
            <div class="row">
              <div class="col-md-auto m-0 p-0"><input type="date" class="form-control" id="kaisai_date_start" name="kaisai_date_start" v-model="kaisai_start0" v-on:change="Check()"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <!-- 対象者 -->
      <tr>
        <th>
          <label for="shokugyo">参加条件</label>
        </th>
        <td>
          <div class="form-group mb-3">
            <div class="form-check form-check-inline">
              <input type="checkbox" class="form-check-input" id="joken_all" name="joken_all" value="すべてを選択／解除" checked="checked" v-on:click="All_joken()" v-model="joken_all0">
              <label class="form-check-label" for="joken_all">すべてを選択／解除</label>
            </div>
          </div>
                
              
                <div class="form-group ">
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[0] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken1" name="joken[]" value="1" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken1">{{gakusei_meisho_list[0]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[1] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken2" name="joken[]" value="2" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken2">{{gakusei_meisho_list[1]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[2] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken3" name="joken[]" value="3" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken3">{{gakusei_meisho_list[2]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[3] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken4" name="joken[]" value="4" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken4">{{gakusei_meisho_list[3]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[4] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken5" name="joken[]" value="5" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken5">{{gakusei_meisho_list[4]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[5] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken6" name="joken[]" value="6" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken6">{{gakusei_meisho_list[5]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_kbn_list[6] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken7" name="joken[]" value="7" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken7">{{gakusei_meisho_list[6]}}</label>
                  </div>
                  <div class="form-check form-check-inline" v-if="gakusei_sanka == 1">
                    <input type="checkbox" class="form-check-input" id="joken8" name="joken[]" value="8" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken8">一般</label>
                  </div>
                </div>
        </td>
        </tr>
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
        </table>
      </div>
</template>

<script setup>
/* eslint-disable */
import { GlobalData, logout, login_check } from '../js/userdata.js';
import { useRouter,useRoute } from 'vue-router'
let router = useRouter()
let route = useRoute()
const cityname = route.params.shakyo
import { ref } from 'vue'

const props = defineProps(['param']);
const emit = defineEmits(['call'])
  const header_logo = props.param.header_logo
  const header_title1 = props.param.header_title1
  const header_title2 = props.param.header_title2
  const title_style1 = props.param.title_style1
  const title_style2 = props.param.title_style2

  // 参加条件（学生区分）
  let gakusei_kbn_list = props.param.gakusei_kbn_list
  let gakusei_meisho_list = props.param.gakusei_meisho_list
  
  // 学生以外の参加（1:有、2:無）
  let gakusei_sanka = ref(1)
  if(props.param.gakusei_sanka){
    gakusei_sanka.value = props.param.gakusei_sanka
  }

  console.log(gakusei_sanka.value)

const ichiran = function() {
   router.push("/"+cityname+"/Taiken" )
}

  // 検索条件
  // プルダウンメニューに表示する値を配列として格納
  let bunrui1_list = ref([])
  let bunrui2_list = ref([])

  let all_bunrui_list = props.param.all_bunrui_list
  let search_param = props.param.search_param // 検索条件
  /*
            search_param = { bunrui1:proc.bunrui10, bunrui2:proc.bunrui20, keyword:proc.keyword0,
                             kaisai_start:proc.kaisai_start0, joken:proc.joken0 , shimekiri:shimekiri}
  */

  // 分類1を格納
  
  for(let b1 = 0;b1<all_bunrui_list.length;b1++){
    let chohuku_flg1 = 0 // 重複してたら格納しない
    if(all_bunrui_list[b1].bunrui == 1){

      for(let b = 0;b<bunrui1_list.value.length;b++){

        console.log(all_bunrui_list[b1]["name"]+"/"+bunrui1_list.value[b])
        // 同じ名前がすでに格納されている場合
        if(all_bunrui_list[b1]["name"] ==  bunrui1_list.value[b]){

          // 重複フラグを立てる
          chohuku_flg1 = 1;

        }
      }

      // 重複してなければ追加
      if(chohuku_flg1 == 0){
        bunrui1_list.value[bunrui1_list.value.length] = all_bunrui_list[b1]["name"]
      }
    }
  }
  
  console.log(bunrui1_list.value)
  // 分類2を格納
  for(let b2 = 0;b2<all_bunrui_list.length;b2++){
    if(all_bunrui_list[b2].bunrui == 2){
      console.log(all_bunrui_list[b2])

      let bunrui1_ok = 0 // この分類2が所属する分類1が存在するなら追加する
      // 分類1を回す
      for(let b1 = 0 ;b1<bunrui1_list.value.length;b1++){
        if(all_bunrui_list[b2].bunrui1_name == bunrui1_list.value[b1]){
          bunrui1_ok = 1
        }
      }
      console.log(bunrui1_ok)
      if(bunrui1_ok == 1){
        
        let chohuku_flg = 0
        for(let b2l = 0;b2l<bunrui2_list.value.length;b2l++){
          if(bunrui2_list.value[b2l]["name"] == all_bunrui_list[b2]["name"]){
            chohuku_flg = 1
          }
        }
        if(chohuku_flg == 0){
          bunrui2_list.value[bunrui2_list.value.length] = all_bunrui_list[b2]
        }
      }
    }
  }

  // 分類1によって絞り込まれた分類2のリスト
  let bunrui2_list_Extract = ref([])
  let bunrui10 = ref("全て") // 分類1
  if(search_param.bunrui1){
    bunrui10.value = search_param.bunrui1
  }
  let bunrui20 = ref("全て") // 分類2
  if(search_param.bunrui2){
    bunrui20.value = search_param.bunrui2
  }
  let shimekiri0 = ref(0) // 申込受付
  if(search_param.shimekiri){
    shimekiri0.value = search_param.shimekiri
  }
  let kaisai_start0 = ref("") // 日程（自）
  if(search_param.kaisai_date){
    kaisai_start0.value = search_param.kaisai_date
  }
   let joken0 = ref(["1","2","3","4","5","6","7","8"]) // 対象者（参加条件）　1：小学、2：中学、3：高校、4：高専、5：専門、6：大学、7：大学院、8：その他

 // let joken0 = ref(["1","2","3","6","8"]) // 対象者（参加条件）　1：小学、2：中学、3：高校、4：高専、5：専門、6：大学、7：大学院、8：その他
  if(search_param.joken){
    joken0.value = search_param.joken
  }
  let keyword0 = ref("") // フリーワード
  if(search_param.keyword){
    keyword0.value = search_param.keyword
  }

// チェックボックス全選択切り替え
let joken_all0 = true // 対象者（参加条件）

//検索を開始する
let Check = function(){  
    //  親コンポーネントへ検索条件を送信する
    emit('call',{cmd:'search',
                bunrui10:bunrui10.value,
                bunrui20:bunrui20.value,
                keyword0:keyword0.value,
                kaisai_date0:kaisai_start0.value,
                joken0:joken0.value,
                shimekiri0:shimekiri0.value});
}
  
/* その他関数の記述 */
// 「対象者（参加条件）」の「すべてを選択／解除」をクリックした時の処理
let All_joken = function(){
    if(joken_all0 == true){
        joken_all0 = false
        joken0.value = []
    } else {
        joken_all0 = true
        joken0.value = ["1","2","3","4","5","6","7","8"]
    // 検索開始
    Check()
    }
}
  // 分類1を変更したとき、分類2を絞り込む
  let bunrui1_change = function(){

    // 現在選択中の分類2は全てに戻す
    bunrui20.value = "全て"
    bunrui2_set()

    // 検索開始
    Check()
  }

  // 分類2を絞り込む処理
  let bunrui2_set = function(){
    
    // 表示する分類2リストを初期化
    bunrui2_list_Extract.value = []

    // 分類1が全てなら、分類2も全て格納する
    if(bunrui10.value == "全て"){

      for(let b2 = 0;b2<bunrui2_list.value.length;b2++){
          bunrui2_list_Extract.value[b2] = bunrui2_list.value[b2]["name"]
      }

    }else{
/*
      let ex_count = 0;//表示する分類2の数
      for(let b2 = 0;b2 < bunrui2_list.value.length;b2++){
          // 分類1が「全て」以外の場合は、その分類1に所属する分類2を表示する
          // 分類1が「全て」の場合は、同じく全ての分類2を表示する
          if(bunrui10.value == bunrui2_list.value[b2]["bunrui1_name"] || bunrui10.value == "全て"){
            bunrui2_list_Extract.value[ex_count] = bunrui2_list.value[b2]["name"]
            ex_count = ex_count + 1

          }
      }*/
     
      let ex_count = 0;//表示する分類2の数
      for(let a = 0;a<all_bunrui_list.length;a++){
        if(all_bunrui_list[a].bunrui == 2){
          if(bunrui10.value == all_bunrui_list[a]["bunrui1_name"] ){
            bunrui2_list_Extract.value[ex_count] = all_bunrui_list[a]["name"]
            ex_count = ex_count + 1
          }
        }
      }
    }
    
  }
  

  /* 初期処理 */

  // 分類２をセット
  bunrui2_set()


</script>
<style scoped>

</style>


